export const styles = {
  container: {
    maxWidth: '100%',
    flexDirection: 'row',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  title: {
    marginLeft: 10,
    fontFamily: "'Proxima Nova', sans-serif",
    fontSize: 16,
    fontWeight: '400',
  },
}
